import React, { SVGProps } from "react";

export default function SupUserCircle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 10C11.6569 10 13 8.65685 13 7C13 5.34315 11.6569 4 10 4C8.34315 4 7 5.34315 7 7C7 8.65685 8.34315 10 10 10ZM10 9C11.1046 9 12 8.10457 12 7C12 5.89543 11.1046 5 10 5C8.89543 5 8 5.89543 8 7C8 8.10457 8.89543 9 10 9Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM15.2389 14.939C16.4548 13.6498 17.2 11.9119 17.2 10C17.2 6.02355 13.9765 2.8 10 2.8C6.02355 2.8 2.8 6.02355 2.8 10C2.8 11.9119 3.54522 13.6498 4.76104 14.939L5.90096 13.1151C6.72327 11.7993 8.1654 11 9.71698 11H10.283C11.8345 11 13.2766 11.7993 14.099 13.115L15.2389 14.939ZM14.4906 15.6284L13.251 13.645C12.6114 12.6217 11.4897 12 10.283 12H9.71698C8.5102 12 7.38854 12.6217 6.74896 13.6451L5.50942 15.6284C6.74061 16.612 8.30163 17.2 10 17.2C11.6984 17.2 13.2594 16.612 14.4906 15.6284Z"
        fill="currentColor"
      />
    </svg>
  );
}
